<form [formGroup]="form" [ngClass]="{'action-dropdown':true}">
    <div class="row sectionBlock">
        <div class="form-group col-md-12 col-sm-12 col-lg-12">
            <div class="text-center">
                <div class="avatar-upload">
                    <div class="avatar-edit">
                        <div class="avatar-preview p-0 m-0">
                            <a class="lead-info">
                                <img src="{{ userProfileImage }}" width="150" height="200">
                            </a>
                        </div>
                        <span class="profile-plushIcon">
                            <img src="{{ userProfilePicOperationIcon }}" height="20" width="20" data-toggle="modal" (click)="setCurrentFileConfig('Photo')">
                        </span>
                    </div>
                </div>
            </div>
        </div>
        <div class="form-group col-md-12 col-sm-12 col-lg-12">
            <!-- 3 column dynamic  -->
            <div class="form-group display-side" *ngFor="let row of preparedRowData">
                <div *ngFor="let field of row" class="col-4" style="margin-right: 2vh;">
                    <label [for]="field.name">{{field.label}}</label>
                    @if (field.type === 'dropdown') {
                    <p-dropdown [options]="field?.options"  [formControlName]="field.name" [(ngModel)]="field.value" appendTo="body"
                        [autoDisplay]="true" (onChange)="onDropdownClick( field, row)" />
                    } @else {
                    <input [id]="field.name" [type]="field.type" [formControlName]="field.name"
                        [attr.placeholder]="field.placeholder" class="form-control d-flex" style="margin-right: 1vh;" />
                    }

                </div>
            </div>
            <div class="actionbtnDiv">
                <button type="submit" class="btn btn-success actionBtn mr-1" (click)="onSubmit()">Submit</button>
                <button type="button" class="btn btn-danger actionBtn mr-2" (click)="Close()">Cancel</button>
            </div>
        </div>
    </div>

</form>

<!--Document Pic upload modal. For uploading document this modal will open -->
<p-dialog [(visible)]="displayDocumentPicDialogue" [modal]="true" [draggable]="false" [resizable]="false"
  [blockScroll]=false [style]="{ width: '30rem' }" (onHide)="receiveCurrentUserProfilePic($event)">
  <p-header>
    Upload {{ documentFileData?.picFor }} Pic
  </p-header>
  <app-document-file [fileDataConfig]='documentFileData'
    (documentFile)="receiveCurrentUserProfilePic($event)"></app-document-file>
</p-dialog>